export const color = {
  primary: "#F15A22",
  secondary: "#214B21",
  darkBlue: "#00133D",
  white: "#FFFFFF",
  darkWhite: "#FCFCFC",
  black: "#000000"
};
